import React, { useMemo, useEffect } from 'react'
import PaginatedPage from '../../components/PaginatedPage'
import TableView from '../../components/TableView'
import BasicDateRenderer from '../../utils/renderers'
import useTranslate, { t } from '../../hooks/useTranslate'
import RolePresenter from '../../api/rolePresenter'

import './translations'
import RoleUpsertForm from './RoleUpsertForm'
import usePermissions from '../../components/usePermissions'
import { useWindowContext, noop } from '@iqueue/ui-kit'

export function RolesTable({ ...props }) {
  const { permissions } = usePermissions()
  const locale = useTranslate()

  const schema = useMemo(() => [{
    key: 'name',
    title: t('rolesPage.table.name'),
    render: (v) => <span>{ v }</span>,
  }, {
    key: 'createdAt',
    title: t('rolesPage.table.createdAt'),
    render: BasicDateRenderer,
    width: '20rem',
  }], [t])

  return <TableView
    permissions={ permissions[RolePresenter.key.toUpperCase()] }
    form={ RoleUpsertForm }
    schema={ schema }
    modalProps={ {
      fullscreen: true,
    } }
    entity={ 'roles' }
    minWidth={ '100rem' }
    { ...props }
  />
}

export default function RolesPage() {
  const { setTitle, togglePaddings, toggleScrollbars } = useWindowContext()
  const locale = useTranslate()
  const translatedTitle = useMemo(() => t('menu.roles'), [locale])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(false)
    toggleScrollbars(true)
  }, [translatedTitle])

  return <PaginatedPage
    presenter={ RolePresenter }
    component={ RolesTable }
  />
}
